<p-dialog
  [header]="'case.document.popup-header' | translate"
  [(visible)]="openPopup"
  [modal]="true"
  [closable]="true"
  (onHide)="clearAll()"
  [style]="{ width: '70%', 'max-height': '75vh', 'overflow-y': 'auto' }"
>
  <div>
    <div class="tabs">
      <button
        class="tab-button"
        [class.active]="activeTab === 'user'"
        (click)="setActiveTab('user')"
      >
        {{ "case.document.portal" | translate }}
      </button>
      <button
        class="tab-button"
        [class.active]="activeTab === 'ambulance'"
        (click)="setActiveTab('ambulance')"
      >
        {{ "case.document.tablet" | translate }}
      </button>
      <button
        class="tab-button"
        [class.active]="activeTab === 'patient'"
        (click)="setActiveTab('patient')"
      >
        {{ "case.document.patient" | translate }}
      </button>

      <button
        class="tab-button"
        [class.active]="activeTab === 'labmed'"
        (click)="setActiveTab('labmed')"
      >
        Labmed
      </button>
      <button
        *ngIf="mode === 'edit'"
        pButton
        type="button"
        icon="pi pi-plus"
        class="mb-2 add-button"
        (click)="addDocument()"
      ></button>
    </div>
    <div class="table-card">
      <p-table
        [value]="filteredDocuments"
        class="custom-table"
        [paginator]="false"
        [scrollable]="true"
        scrollHeight="45vh"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%" scope="col">{{ "case.document.file-name" | translate }}</th>
            <th style="width: 20%" scope="col">
              {{ "case.document.file-description" | translate }}
            </th>
            <th style="width: 20%" scope="col">{{ "case.document.created-by" | translate }}</th>
            <th style="width: 20%" scope="col">{{ "case.document.created-at" | translate }}</th>
            <th style="width: 20%" scope="col"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-doc>
          <tr>
            <td class="file-name">
              <i
                [class]="
                  doc.mimeType && doc.mimeType?.includes('image')
                    ? 'pi pi-image'
                    : 'pi pi-file'
                "
              ></i>
              {{ doc.fileName }}
            </td>

            <td class="text-gray">{{ doc.description }}</td>

            <td>
              <div class="user-cell">
                @if (doc.savedType === 'patient') {
                  <i class="fa-solid fa-user"></i>
                } @else if (doc.savedType === 'ambulance') {
                  <i class="fa-solid fa-truck-medical"></i>
                } @else if (doc.savedType === 'user') {
                  <i class="fa-solid fa-desktop"></i>
                }

                <span class="user-name mx-2">{{ doc.createdBy }}</span>
              </div>
            </td>

            <td class="text-gray">{{ doc.createdAt | dateFormat : true }}</td>

            <td>
              <button
                pButton
                type="button"
                icon="pi pi-download"
                class="p-button-rounded p-button-text warning-btn"
                (click)="download(doc)"
              ></button>
              <button
                *ngIf="mode === 'edit'"
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-text danger-btn"
                (click)="deleteClick(doc)"
              ></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center">
              {{ "common.noData" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

<app-upload-file-upload-dialog
  #fileUploadDialog
  (fileAdded)="onSaveFile($event)"
  [moduleName]="'case'"
></app-upload-file-upload-dialog>
